// select the correct language here
// import language from './../../src/common/i18n/et_EE.json';
// import language from './../../src/common/i18n/en_uk.json';

import language from "./../../src/common/i18n/fr_FR.json";

const dictionary = language;
// if needed change some strings here or add some
dictionary.notifications_title = "oops";
dictionary.recently = "Dernières éditions";
dictionary.NewspaperCurrentlyUnavailable =
  "Votre journal est indisponible pour le moment. Veuillez nous en excuser et réessayer dans quelques instants.";
dictionary.ValidationFailed =
  "Nos systèmes d'authentification sont temporairement indisponibles. Veuillez nous en excuser et réessayer dans quelques instants.";
dictionary.SSOValidationFailed =
  "Nos systèmes d'authentification sont temporairement indisponibles. Veuillez nous en excuser et réessayer dans quelques instants.";
dictionary.UnknownError =
  "Nos systèmes ont repéré une erreur liée à votre authentification. Merci de vérifier la saisie de vos identifiants (email et mot de passe) ou de réessayer dans quelques instants.";
dictionary.E1 =
  "Nos systèmes sont temporairement indisponibles. Veuillez nous en excuser et réessayer dans quelques instants.";
dictionary.E3 =
  "Nos systèmes d'authentification sont temporairement indisponibles. Veuillez nous en excuser et réessayer dans quelques instants.";
dictionary.E4 =
  "Nos systèmes sont temporairement indisponibles. Veuillez nous en excuser et réessayer dans quelques instants.";
dictionary.E5 =
  "Nos systèmes ne reconnaissent pas d'abonnement actif lié à vos identifiants. Merci de prendre contact avec notre Service Clients pour que nous puissions vous aider.";
dictionary.E6 =
  "Vos identifiants adresse mail et/ou mot de passe sont incorrects. Merci de vérifier, s'il vous plaît, votre saisie et réessayer de vous connecter.  Le cas échéant, nous vous invitons à prendre contact avec notre Service Clients afin que nous puisssions vous aider.";
dictionary.E7 =
  "Vos identifiants adresse mail et/ou mot de passe sont incorrects. Merci de vérifier, s'il vous plaît, votre saisie et réessayer de vous connecter.  Le cas échéant, nous vous invitons à prendre contact avec notre Service Clients afin que nous puisssions vous aider.";
dictionary.E8 =
  "Votre journal est indisponible pour le moment. Veuillez nous en excuser et réessayer dans quelques instants.";
dictionary.E9 =
  "Nos systèmes sont temporairement indisponibles. Veuillez nous en excuser et réessayer dans quelques instants.";
dictionary.E11 =
  "Vous avez atteint la limite du nombre d'appareils distincts autorisés à consulter cette publication.";
dictionary.E13 =
  "Nos systèmes sont temporairement indisponibles. Veuillez nous en excuser et réessayer dans quelques instants.";
dictionary.E15 =
  "Nos systèmes sont temporairement indisponibles. Veuillez nous en excuser et réessayer dans quelques instants.";
dictionary.E16 =
  "Nos systèmes ont repéré une erreur liée à votre authentification. Merci de vérifier la saisie de vos identifiants (email et mot de passe) ou de réessayer dans quelques instants.";
dictionary.E17 =
  "Nos systèmes d'authentification sont temporairement indisponibles. Veuillez nous en excuser et réessayer dans quelques instants.";
dictionary.E20 =
  "Nos systèmes d'authentification sont temporairement indisponibles. Veuillez nous en excuser et réessayer dans quelques instants.";
dictionary.E21 =
  "Nos systèmes d'authentification sont temporairement indisponibles. Veuillez nous en excuser et réessayer dans quelques instants.";
dictionary.E24 =
  "Nos systèmes sont temporairement indisponibles ou votre abonnement ne vous permet pas d'accèder à ce journal. Veuillez nous en excuser et réessayer dans quelques instants. Si le phénomène perdure, nous vous invitons à prendre contact avec notre Service Clients pour que nous puissions vous aider.";
dictionary.E25 =
  "Vous avez atteint le nombre maximal d'accès simultanés pour cet abonnement. Veuillez réessayer plus tard.";
dictionary.E26 =
  "Nos systèmes ont repéré une erreur liée à votre authentification. Merci de vérifier la saisie de vos identifiants (email et mot de passe) ou de réessayer dans quelques instants. Si le phénomène perdure, nous vous invitons à contacter notre Service Clients pour que nous puissions vous aider.";
dictionary.printImage = "Version article";
dictionary.printText = "Version texte";
export default dictionary;



// WEBPACK FOOTER //
// ./clients/cfr-mt/dictionary.js